/* Tiras que avanzan solas (galería de fotos y capítulos del tour).
   El contenido va duplicado en el HTML: al llegar a la mitad vuelve al inicio y el salto no se nota.

   data-velocidad: píxeles por segundo.
   data-hover: "parar" se detiene del todo al pasar el mouse · "lento" solo baja la marcha.
   data-modo: "scroll" mueve la barra de desplazamiento real, así el visitante puede arrastrar
              y el avance automático no se le pelea. Sin esto, se mueve con transform. */
(() => {
  const FACTOR = { parar: 0, lento: 0.22 };
  const SUAVIZADO = 3.5; // qué tan rápido cambia de velocidad, para que no dé un tirón

  const montar = (tira) => {
    tira.dataset.listo = 'true';
    const marco = tira.parentElement;
    const velocidad = parseFloat(tira.dataset.velocidad) || 30;
    const factorHover = FACTOR[tira.dataset.hover] ?? 0;
    const porScroll = tira.dataset.modo === 'scroll';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let pos = 0;
    let fijado = 0;
    let actual = velocidad;
    let objetivo = velocidad;
    let raf = null;
    let anterior = 0;
    let arrastrando = false;

    const paso = (ahora) => {
      const dt = Math.min((ahora - anterior) / 1000, 0.05);
      anterior = ahora;
      actual += (objetivo - actual) * Math.min(1, dt * SUAVIZADO);

      const mitad = tira.scrollWidth / 2;

      if (porScroll) {
        // si el visitante movió la tira por su cuenta, se retoma desde donde él la dejó
        if (Math.abs(marco.scrollLeft - fijado) > 1) pos = marco.scrollLeft;
        pos += actual * dt;
        if (mitad > 0) {
          if (pos >= mitad) pos -= mitad;
          if (pos < 0) pos += mitad;
        }
        marco.scrollLeft = pos;
        fijado = marco.scrollLeft;
      } else {
        pos -= actual * dt;
        if (mitad > 0) {
          while (-pos >= mitad) pos += mitad;
          while (pos > 0) pos -= mitad;
        }
        tira.style.transform = `translate3d(${pos.toFixed(2)}px, 0, 0)`;
      }

      raf = requestAnimationFrame(paso);
    };

    const arrancar = () => {
      if (raf) return;
      anterior = performance.now();
      raf = requestAnimationFrame(paso);
    };
    const parar = () => {
      if (!raf) return;
      cancelAnimationFrame(raf);
      raf = null;
    };

    const frenar = () => { objetivo = velocidad * factorHover; };
    const soltar = () => { if (!arrastrando) objetivo = velocidad; };

    marco.addEventListener('mouseenter', frenar);
    marco.addEventListener('mouseleave', soltar);
    marco.addEventListener('focusin', frenar);
    marco.addEventListener('focusout', soltar);
    marco.addEventListener('touchstart', frenar, { passive: true });
    marco.addEventListener('touchend', soltar, { passive: true });

    // arrastrar con el mouse, que si no en computador no hay forma de moverla a mano
    if (porScroll) {
      let inicioX = 0;
      let inicioScroll = 0;

      marco.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch') return; // el táctil ya se desplaza solo
        arrastrando = true;
        objetivo = 0;
        inicioX = e.clientX;
        inicioScroll = marco.scrollLeft;
        marco.setPointerCapture(e.pointerId);
        marco.classList.add('tira--agarrada');
      });

      marco.addEventListener('pointermove', (e) => {
        if (!arrastrando) return;
        marco.scrollLeft = inicioScroll - (e.clientX - inicioX);
        pos = marco.scrollLeft;
        fijado = pos;
      });

      const terminar = (e) => {
        if (!arrastrando) return;
        arrastrando = false;
        marco.classList.remove('tira--agarrada');
        if (e && e.pointerId != null && marco.hasPointerCapture(e.pointerId)) {
          marco.releasePointerCapture(e.pointerId);
        }
        objetivo = marco.matches(':hover') ? velocidad * factorHover : velocidad;
      };

      marco.addEventListener('pointerup', terminar);
      marco.addEventListener('pointercancel', terminar);
      marco.addEventListener('dragstart', (e) => e.preventDefault());
    }

    new IntersectionObserver((entradas) => {
      if (entradas[0].isIntersecting) arrancar();
      else parar();
    }, { threshold: 0 }).observe(marco);
  };

  const init = () => document.querySelectorAll('[data-tira]:not([data-listo])').forEach(montar);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
